import styled from '@emotion/styled';
import { Div } from '../../layouts';

export const AdvertisementContainer = styled(Div)`
    & .od-carousel-content-top {
        z-index: 15;
    }

    & .od-carousel-background {
        z-index: 0;
    }

    & * {
        box-sizing: border-box;
    }
`;
